import React from "react";
import { Redirect } from "react-router-dom";
import { Form, Grid } from "semantic-ui-react";
import styled from "styled-components";
import { Paths } from "../Constants";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import PillButton from "./common/PillButton";
import SFCookieConsent from "./common/SFCookieConsent";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import ErrorDisplay from "./ErrorDisplay";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const StyledForm = styled(Form)`
  width: 400px;
  margin-top: 180px;
`;

class Login extends BaseComponent {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      showActivityIndicator: false,
    };

    this.validateEntry = this.validateEntry.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.login = this.login.bind(this);
  }

  validateEntry() {
    this.errorManager.reset();
    // do we need this?
  }

  onSubmit() {
    // call service here..
  }

  async login() {
    const email = this.state.email;
    const password = this.state.password;
    this.errorManager.reset();

    if (email == null) {
      this.errorManager.addError("You must enter your email to login");
      this.forceUpdate();
      return;
    }
    if (password === null || password === "") {
      this.errorManager.addError("You must enter a password to login");
      this.forceUpdate();
      return;
    }

    this.setState({ showActivityIndicator: true });
    const trimmedEmail = String.prototype.trim.call(email);


    try {
      await this.identityApi.loginUser(trimmedEmail, password);
    } catch (err) {
      if (err.response) {
        switch (err.response.status) {
          case 500:
            this.errorManager.addError("Unexpected Error");
            break;
          case 400:
            console.log(err.response);
            this.errorManager.addError(
              "Failed to login. Please check your username and password."
            );
            break;
          default:
            //Need to communicate this to us somehow
            this.errorManager.addError("Unknown Error: " + err);
        }
      } else {
        this.errorManager.addError("Unknown Error: " + err);
        //Need to communicate this to us somehow
      }
      this.setState({ showActivityIndicator: false });
      return;
    }

    this.setState({
      showActivityIndicator: false,
      password: "",
      redirectPath: Paths.CHECK_ACCOUNT_STATUS,
    });
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Sign In" />
        <SFLoader active={this.state.showActivityIndicator} />
        <MainContentWrapper>
          <Wrapper>
          <StyledForm>
              <Form.Input
                onChange={(e) => {
                  this.setState({ email: e.target.value });
                }}
                onBlur={(e) => {
                  this.validateEntry();
                }}
                placeholder="Enter your email"
              />
              <Form.Input
                onChange={(e) => {
                  this.setState({ password: e.target.value });
                }}
                onBlur={(e) => {
                  this.validateEntry();
                }}
                placeholder="Enter your password"
                type="password"
              />
              {this.errorManager.getErrorCount() > 0 ? (
                <ErrorDisplay errorManager={this.errorManager} />
              ) : null}

              <Grid columns={2}>
                <Grid.Row>
                  <Grid.Column>
                    <PillButton
                      primary
                      style={{ width: "100%" }}
                      onClick={() => this.login()}
                    >
                      Submit
                    </PillButton>
                  </Grid.Column>
                  <Grid.Column
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <a
                      href={Paths.REQUEST_PASSWORD_CHANGE}
                      style={{ width: "100%", textAlign: "right" }}
                    >
                      Forgot Password
                    </a>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </StyledForm>
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default Login;
